export let tabNamesArr = [
    'Owner Information',
    'Emergency Contact',
    'Pickup Authorization',
    'Pet Information',
    'Behavioral Information',
    'Health History',
    'Waiver',
    'Review'
]